interface StorageParams {
  name: string
  content: any
  type?: 'local' | 'session'
}

interface StoredData {
  dataType: string
  content: any
  type: 'local' | 'session'
  dateTime: number
}

export const setStore = (params: StorageParams): void => {
  const { name, content, type = 'session' } = params

  const obj: StoredData = {
    dataType: typeof content,
    content: content,
    type: type,
    dateTime: new Date().getTime()
  }

  if (type === 'local') {
    window.localStorage.setItem(name, JSON.stringify(obj))
  } else {
    window.sessionStorage.setItem(name, JSON.stringify(obj))
  }
}

export const getStore = (name: string, type: 'local' | 'session' = 'session'): any => {
  let storage
  if (type === 'local') {
    storage = window.localStorage.getItem(name)
  } else {
    storage = window.sessionStorage.getItem(name)
  }

  if (!storage) {
    return null
  }

  const obj: StoredData = JSON.parse(storage)

  if (obj.dataType === 'number') {
    return Number(obj.content)
  } else if (obj.dataType === 'boolean') {
    return obj.content === 'true'
  } else if (obj.dataType === 'object') {
    return JSON.parse(obj.content)
  } else {
    return obj.content
  }
}

export const removeStore = (name: string) => {
  window.localStorage.removeItem(name)
  window.sessionStorage.removeItem(name)
}

export const clearStore = (params: { type: 'local' | 'session' }) => {
  const { type } = params
  if (type) {
    window.sessionStorage.clear()
    return
  }
  window.localStorage.clear()
}
